import React, { useState } from "react";
import PageContainer from "../PageContainer";
import useCurrencies from "../../hooks/useCurrencies";
import CurrencyCollection from "../../components/CurrencyCollection";
import axios from "axios";
import useErrorHandler from "../../hooks/userErrorHandler";
import useDenominations from "../../hooks/useDenominations";

export default () => {
  const [changeCount, setChangeCount] = useState(0);
  const [denomChangeCount, setDenomChangeCount] = useState(0);
  const { currencies } = useCurrencies(true, [changeCount]);
  const setError = useErrorHandler();
  const [selectedCurrency, setSelectedCurrency] = useState<string>();
  const {
    denominations,
    denominationsLoading
  } = useDenominations(selectedCurrency, true, [denomChangeCount]);

  return (
    <div className="ConfigurationContainer-container">
      <PageContainer title="Configuration">
        <CurrencyCollection
          currencies={currencies}
          denominations={denominations}
          onSelectCurrency={setSelectedCurrency}
          onEnable={async (currency: any, enabled: boolean) => {
            try {
              await axios.put(
                enabled
                  ? `/api/Currencies/${currency.id}/enable`
                  : `/api/Currencies/${currency.id}/disable`,
                {
                  version: currency.version
                },
                {
                  headers: {
                    "Content-Type": "application/json"
                  }
                }
              );
            } catch (err) {
              if (
                err &&
                err.response &&
                err.response.status === 409 &&
                err.response.data.problems &&
                err.response.data.problems[0].problemKey ===
                  "Currency.UpdatedByAnotherUser"
              ) {
                setError(
                  "Currency was updated by another user. Refreshing results.",
                  err
                );
              } else {
                setError(
                  enabled
                    ? "Unable to enable currency"
                    : "Unable to disable currency",
                  err
                );
              }
            }

            setChangeCount(c => c + 1);
          }}
          onEnableDenomination={async (denomination: any, enabled: boolean) => {
            if (denominationsLoading) {
              return;
            }
            try {
              await axios.put(
                enabled
                  ? `/api/Currencies/${selectedCurrency}/denominations/${denomination.id}/enable`
                  : `/api/Currencies/${selectedCurrency}/denominations/${denomination.id}/disable`,
                {
                  version: denomination.version
                },
                {
                  headers: {
                    "Content-Type": "application/json"
                  }
                }
              );
            } catch (err) {
              if (
                err &&
                err.response &&
                err.response.status === 409 &&
                err.response.data.problems &&
                err.response.data.problems[0].problemKey ===
                  "Denomination.UpdatedByAnotherUser"
              ) {
                setError(
                  "Denomination was updated by another user. Refreshing results.",
                  err
                );
              } else {
                setError(
                  enabled
                    ? "Unable to enable the denomination"
                    : "Unable to disable the denomination",
                  err
                );
              }
            }

            setDenomChangeCount(c => c + 1);
          }}
          denominationsLoading={denominationsLoading}
        />
      </PageContainer>
    </div>
  );
};
